/* ============================================================
   Olivia & Jack — kleurstalen (Swatch King-look) voor Horizon.
   Zet de "Color"-opties van Horizons variantkiezer om naar
   VIERKANTE image-swatches: elke kleur toont de productfoto van
   die variant. Geen foto? Dan een effen kleurvlak als terugval.
   Native selectie blijft werken: klik = variant kiezen; prijs,
   afbeelding en cart updaten gewoon mee. Maten blijven knoppen.
   ============================================================ */
(function () {
  'use strict';

  var COLOR_NAMES = /colou?r|kleur|couleur|farbe/i;
  var COLOR_IMG = {};   // genormaliseerde kleurnaam -> variant-afbeelding
  var imagesLoaded = false;

  var MAP = {
    'green – hannelore': '#3f8f4f',
    'plum purple': '#6f2d5c', 'taupe': '#9f8a78',
    'taupe with black print': 'linear-gradient(135deg,#9f8a78 0%,#9f8a78 55%,#111111 55%,#111111 100%)',
    'blue & gold marble': 'linear-gradient(135deg,#2f5872 0%,#2f5872 55%,#b99a58 55%,#b99a58 100%)',
    'blue & gold marble – teresa': 'linear-gradient(135deg,#2f5872 0%,#2f5872 55%,#b99a58 55%,#b99a58 100%)',
    'blue & gold marble – alison': 'linear-gradient(135deg,#2f5872 0%,#2f5872 55%,#b99a58 55%,#b99a58 100%)',
    'black & gold marble': 'linear-gradient(135deg,#111111 0%,#111111 55%,#b99a58 55%,#b99a58 100%)',
    'purple & white': 'linear-gradient(135deg,#7b4aa0 0%,#7b4aa0 50%,#ffffff 50%,#ffffff 100%)',
    'white & red': 'linear-gradient(135deg,#ffffff 0%,#ffffff 50%,#c0392b 50%,#c0392b 100%)',
    'green & white': 'linear-gradient(135deg,#3f8f4f 0%,#3f8f4f 50%,#ffffff 50%,#ffffff 100%)',
    'orange': '#e8752b', 'burnt orange': '#c1541f',
    'red': '#c0392b', 'wine': '#7b2233', 'burgundy': '#6d1f2c', 'maroon': '#5c1f2b',
    'pink': '#e88aa8', 'light pink': '#f6c6d4', 'dark pink': '#c94f7c',
    'dusty pink': '#c98a94', 'hot pink': '#e75480', 'rose': '#d98a9a',
    'purple': '#7b4aa0', 'light purple': '#c3a6dd', 'lavender': '#c9b6e4',
    'green': '#3f8f4f', 'light green': '#a9d4a0', 'dark green': '#25502f',
    'olive green': '#6b6b23', 'light olive green': '#9aa06a', 'olive': '#808000',
    'army green': '#4b5320', 'mint': '#a8e0c0', 'teal': '#2b8a8a',
    'blue': '#3b5aa6', 'light blue': '#a8c8e6', 'light blue 2': '#c2dbef',
    'powder blue': '#b6d0e2', 'steel blue': '#4a72a0', 'slate blue': '#5b6b95',
    'dark blue': '#1f3a66', 'navy blue': '#1b2a4a', 'navy': '#1b2a4a', 'sky blue': '#8ec5e8', 'turquoise': '#40c0c0',
    'yellow': '#e7c14b', 'light yellow': '#f2e39a', 'mustard': '#c9992b', 'gold': '#c9a24a',
    'white': '#ffffff', 'white 2': '#f2efe6', 'cream': '#f4ecd8', 'ivory': '#f7f3e8', 'beige': '#e3d5b8',
    'black': '#111111', 'charcoal': '#36393b',
    'gray': '#8c8c8c', 'grey': '#8c8c8c', 'light gray': '#cfcfcf', 'light grey': '#cfcfcf',
    'dark gray': '#4a4a4a', 'dark grey': '#4a4a4a', 'silver': '#c9c9c9',
    'khaki': '#b8a06a', 'brown': '#6b4a2b', 'tan': '#c9a877', 'camel': '#c19a6b',
    'coffee': '#4b3621', 'coral': '#e5735b', 'apricot': '#f0a868', 'peach': '#f4c2a1'
  };

  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  var probe;
  function isCssColor(name) {
    if (!probe) probe = document.createElement('span');
    probe.style.color = '';
    try { probe.style.color = name; } catch (e) {}
    return probe.style.color !== '';
  }

  function colorFor(value) {
    var n = norm(value);
    if (MAP[n]) return MAP[n];
    if (/multi|print|floral|geo|colou?rful|patchwork|stripe|mixed|pattern/.test(n)) {
      return 'conic-gradient(from 0deg,#e74c3c,#f1c40f,#2ecc71,#3498db,#9b59b6,#e74c3c)';
    }
    var base = n.replace(/\b(light|dark|deep|pale|bright|soft|dusty|medium|neon|hot|baby)\b/g, '').trim();
    if (MAP[base]) return MAP[base];
    if (isCssColor(n.replace(/ /g, ''))) return n.replace(/ /g, '');
    if (isCssColor(base.replace(/ /g, ''))) return base.replace(/ /g, '');
    return '#bdbdbd';
  }

  function isColorFieldset(fs) {
    var lg = fs.querySelector('legend');
    return lg ? COLOR_NAMES.test(lg.textContent || '') : false;
  }

  function withWidth(src, w) {
    if (!src) return src;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function loadImages() {
    var path = location.pathname.replace(/\/+$/, '');
    fetch(path + '.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.options) return;
        var names = p.options.map(function (o) { return (typeof o === 'string') ? o : o.name; });
        var idx = names.findIndex(function (n) { return COLOR_NAMES.test(n); });
        if (idx < 0) return;
        (p.variants || []).forEach(function (v) {
          var c = norm(v['option' + (idx + 1)]);
          if (c && !COLOR_IMG[c] && v.featured_image && v.featured_image.src) {
            COLOR_IMG[c] = withWidth(v.featured_image.src, 200);
          }
        });
        imagesLoaded = true;
        apply(document);
      })
      .catch(function () {});
  }

  function updateColorLabels(root) {
    var fieldsets = (root || document).querySelectorAll('variant-picker fieldset');
    for (var j = 0; j < fieldsets.length; j++) {
      var fs = fieldsets[j];
      if (!isColorFieldset(fs)) continue;
      var checked = fs.querySelector('input[type="radio"]:checked');
      var selected = fs.querySelector('.oj-selected-color');
      if (selected && checked) selected.textContent = ': ' + checked.value;
      // Native Horizon swatches also expose a selected-value span.
      var nativeLabel = fs.querySelector('legend .variant-option__swatch-value');
      if (nativeLabel && checked) nativeLabel.textContent = checked.value;
    }
  }

  function apply(root) {
    var pickers = (root || document).querySelectorAll('variant-picker');
    for (var p = 0; p < pickers.length; p++) {
      var fss = pickers[p].querySelectorAll('fieldset');
      for (var f = 0; f < fss.length; f++) {
        if (!isColorFieldset(fss[f])) continue;
        fss[f].classList.add('hp-swatch-group');
        var labels = fss[f].querySelectorAll('.variant-option__button-label');
        for (var i = 0; i < labels.length; i++) {
          var lb = labels[i];
          var input = lb.querySelector('input');
          var val = input ? input.value : lb.textContent;
          var img = COLOR_IMG[norm(val)];
          // Always (re)set — Horizon re-renders the picker on variant change.
          lb.style.setProperty('--sw', colorFor(val));
          if (img) {
            lb.style.backgroundImage = 'url("' + img + '")';
            lb.classList.add('hp-swatch--img');
          } else {
            lb.style.backgroundImage = 'none';
            lb.classList.remove('hp-swatch--img');
          }
          lb.setAttribute('title', (val || '').trim());
          if (!lb.classList.contains('hp-swatch')) lb.classList.add('hp-swatch');
        }
      }
    }
    updateColorLabels(root);
  }

  function injectCss() {
    if (document.getElementById('hp-swatch-css')) return;
    var css = [
      'label.hp-swatch{--sw:#ccc;position:relative;display:inline-flex;align-items:center;justify-content:center;',
      'width:52px!important;height:52px!important;min-width:52px!important;max-width:52px!important;padding:0!important;',
      'box-sizing:border-box!important;border-radius:4px!important;border:1px solid #d9d9d9!important;',
      'background-color:var(--sw)!important;background-size:cover!important;background-position:center!important;background-repeat:no-repeat!important;',
      'font-size:0!important;color:transparent!important;cursor:pointer;overflow:hidden;box-shadow:none!important;transition:transform .12s ease;}',
      'label.hp-swatch input{position:absolute;inset:0;opacity:0;margin:0;cursor:pointer;}',
      'label.hp-swatch .variant-option__button-label__pill,label.hp-swatch .variant-option__button-label__text{display:none!important;background:none!important;}',
      'label.hp-swatch:hover{transform:translateY(-1px);}',
      'label.hp-swatch:has(input:checked){border:2px solid var(--color-foreground,#111)!important;outline:none!important;box-shadow:none!important;}',
      'label.hp-swatch:has(input:disabled){opacity:.4;}',
      '.hp-swatch-group{display:flex;flex-wrap:wrap;gap:10px;}',
      // Maatknoppen (niet-kleur opties) compacter maken.
      'variant-picker fieldset:not(.hp-swatch-group) .variant-option__button-label{min-height:34px!important;padding:5px 12px!important;font-size:13px!important;}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'hp-swatch-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  // Cart drawer opent direct bij "Add to cart": zet het auto-open attribuut
  // op Horizons cart-drawer-component (dan opent de lade via CartAddEvent).
  function enableCartAutoOpen() {
    var cd = document.querySelector('cart-drawer-component');
    if (cd && !cd.hasAttribute('auto-open')) cd.setAttribute('auto-open', '');
  }

  // Footer "About us" / "Store hours" accordions: op desktop (>=750px) open
  // en normaal tonen; op mobiel ingeklapt als dropdown (net als de menu's).
  function footerAccordions() {
    var open = window.innerWidth >= 750;
    var dets = document.querySelectorAll('.footer-content .accordion details');
    for (var i = 0; i < dets.length; i++) {
      if (open) { dets[i].setAttribute('open', ''); }
      else { dets[i].removeAttribute('open'); }
    }
  }
  var faTimer;
  window.addEventListener('resize', function () {
    clearTimeout(faTimer);
    faTimer = setTimeout(footerAccordions, 150);
  });

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; apply(document); enableCartAutoOpen(); footerAccordions(); });
  }
  function retry() { schedule(); setTimeout(function () { apply(document); }, 150); setTimeout(function () { apply(document); }, 450); setTimeout(function () { apply(document); }, 900); }

  function init() {
    injectCss();
    apply(document);
    loadImages();
    enableCartAutoOpen();
    footerAccordions();
    // New nodes (quick-add modal, section swap)
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    // Variant change re-renders the picker in place -> re-apply on radio change
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.tagName === 'INPUT' && t.type === 'radio') {
        updateColorLabels(document);
        retry();
      }
    }, true);
    document.addEventListener('shopify:section:load', function () { imagesLoaded = false; COLOR_IMG = {}; loadImages(); schedule(); });
    [300, 900, 1800].forEach(function (t) { setTimeout(function () { apply(document); }, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
